<app-banner *ngIf="hasBanner" 
  [banner]="banner"
  [type]="type">
</app-banner>

<div class="page-text" *ngIf="hasPageText && hasBanner">
  <div class="container">
    <app-page-text 
    [text]="text" >
    </app-page-text>
  </div>
</div>

<div class="page-text" *ngIf="hasPageText && !hasBanner">
    <div class="container">
      <h1>{{ name }}</h1>
      <app-page-text 
      [text]="text" >
      </app-page-text>
    </div>
</div>

<div class="homeblocks-wrapper" *ngIf="hasBlocks">
    <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
      <app-blocks 
      [type]="type" 
      [blocks]="blocks">
    </app-blocks>
    </div>
</div>